import { ApiError } from "../api/client";
import { text } from "../text";

/** Why an input was rejected, by the server or by a check in the form, shown inside a sheet where the page banner is covered. */
export function ErrorNote({ error }: { error: Error | null | undefined }) {
  if (!error) return null;
  return (
    <div className="error-banner" role="alert">
      {error instanceof ApiError && error.messages.length > 0 ? error.messages.map((m, i) => <div key={i}>{text(m.text)}</div>) : error.message}
    </div>
  );
}
